import { configureStore } from '@reduxjs/toolkit'
import experimentFileReducer from './reducers/experimentFile'

export default configureStore({
  reducer: {
    experimentFiles: experimentFileReducer
  }
})
